'use strict';

namespace Core {
    interface IAtolProtectedCost {
        Quantity: number;
        UnitAmount: number;
        AtolProtected: boolean;
        ClientCurrencyCode: string;
    }

    interface IBookingDetailRouteParams extends ng.route.IRouteParamsService {
        tripId: string;
    }

    class AtolCostBreakdown {
        costs: IAtolProtectedCost[];
        totalLabel: string;
        atolSubtotalLabel: string;

        atolProtectedCosts: IAtolProtectedCost[];
        otherCosts: IAtolProtectedCost[];
        total: number;
        atolSubTotal: number;
        clientCurrencyCode: string;

        constructor(
            private $scope: ng.IScope,
            private tripService: TripService,
            private $routeParams: IBookingDetailRouteParams) {

            const killTheWatch = $scope.$watchCollection(() => this.costs,
                (val) => {
                    if (val) {
                        let costs = _.groupBy(this.costs, 'AtolProtected');
                        this.atolProtectedCosts = costs['true'];
                        this.otherCosts = costs['false'];
                        this.total = this.sumCosts(this.costs);
                        this.atolSubTotal = this.sumCosts(this.atolProtectedCosts);
                        this.setClientCurrencyCode();
                        killTheWatch();
                    }
                });
        }

        private sumCosts(costs: IAtolProtectedCost[]) {
            if (costs) {
                return costs.reduce((sum, item) => sum + item.Quantity * item.UnitAmount, 0);
            }
            return 0;
        }

        private setClientCurrencyCode() {
            if (this.costs && (this.costs.length >= 1)) {
                if (this.costs[0].ClientCurrencyCode) {
                    this.clientCurrencyCode = this.costs[0].ClientCurrencyCode;
                } else {
                    this.tripService.getCurrency(this.$routeParams.tripId).then(currency => {
                        this.clientCurrencyCode = currency;
                    });
                }
            }
        }
    }

    angular
        .module('core')
        .directive('atolCostBreakdown', (): ng.IDirective => {
            return {
                restrict: 'E',
                replace: true,
                scope: {},
                bindToController: {
                    costs: '=',
                    totalLabel: '@',
                    atolSubtotalLabel: '@'
                },
                controller: AtolCostBreakdown,
                controllerAs: 'acb',
                templateUrl: 'partials/home/atolcostbreakdown'
            };
        });
}
